export default __webpack_public_path__ + "static/media/video-placeholder.75e38c6f.jpg";